import Main from '../components/Feed/Main'

const feedElement = document.getElementById('feed');
const feedType = feedElement.getAttribute('data-feed-type');
const userId = feedElement.getAttribute('data-user-id');
const hashtag = feedElement.getAttribute('data-hashtag');
const excludedPostIds = feedElement.getAttribute('data-excluded-post-ids');
const featuredPostId = feedElement.getAttribute('data-featured-post-id');

// render vue app
new window.Vue({
    render: h => h(Main, {
        props: {
            feedType,
            userId,
            hashtag,
            excludedPostIds,
            featuredPostId,
        },
    }),
}).$mount('#feed');
